<template>
  <section class="section participants container">
    <h2 class="large-title participants__title">Наші фіналістки</h2>
    <div v-if="candidates.length <= 0">Завантаження...</div>
    <div v-else class="participants__items flex wrap jc-center">
      <CandidateComponent
        v-for="(candidate, i) in candidates"
        :key="candidate.id"
        :candidate="candidate"
        :index="i"
      />
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref } from "vue";

import CandidateComponent from "./CandidateComponent.vue";

const candidates = ref([]);

onMounted(async () => {
  candidates.value = [
    // ДОЛГОПОЛОВА
    {
      id: 1,
      imageUrl: require("../assets/images/queens/2026_3/dolgopolova.png"),
      fullName: "",
      description:
        "Марія Долгополова — сильна, цілеспрямована жінка, яка поєднує жіночність, професіоналізм і незламний характер. За освітою інженер, до 2022 року працювала у сімейному будівельному бізнесі та розвивалася в модельній сфері.</br></br>Марія брала участь у конкурсах краси, де здобула низку призових місць і почесних титулів.</br></br>Із початком повномасштабної війни вона здобула освіту медичної сестри, пройшла курси тактичної медицини та добровільно вступила до лав ЗСУ. Нині служить оператором БПЛА, виконує бойові завдання на Донбаському та Запорізькому напрямках.</br></br>Її історія — приклад мужності, відданості Україні та сили духу. Марія доводить, що справжня краса проявляється не лише в зовнішності, а й у вчинках і готовності захищати свою країну.",
      story: "",
      // voteCount: 138,
      voteCount: 138 + 96,
      link: "https://send.monobank.ua/jar/962vd5grmC",
    },
    // ГІРНИК
    {
      id: 2,
      imageUrl: require("../assets/images/queens/2026_3/girnik.png"),
      fullName: "",
      description:
        "Інесса Гирник — щира, сильна й натхненна жінка з Харкова, щаслива мама двох синів, які є її головною підтримкою та натхненням.</br></br>З дитинства вона мріяла про модельну кар’єру й не дозволила життєвим обставинам завадити своїй мрії. Інесса переконана, що справжня сила — у вірі в себе та сміливості йти до своїх цілей.</br></br>Для неї участь у конкурсі — це не лише про красу, а й про жіночність, внутрішню гармонію та можливість надихнути інших жінок. Власним прикладом вона доводить, що для здійснення мрій немає вікових обмежень, якщо є віра в себе та любов до життя.",
      story: "",
      // voteCount: 143,
      voteCount: 143 + 75,
      link: "https://send.monobank.ua/jar/5zq7BhUAi9",
    },
    // ІЛЬЧУК
    {
      id: 3,
      imageUrl: require("../assets/images/queens/2026_3/ilchuk.png"),
      fullName: "",
      description:
        "Валерія — ветеринарний лікар, мама чудового сина та жінка, яка вірить, що справжня краса народжується з доброти, сили характеру, щирості та любові до життя.</br></br>З п’яти років вона мріяла стати моделлю й одного дня вийти на сцену конкурсу краси. Ця мрія навчила її ніколи не відмовлятися від своїх цілей.</br></br>Професійний шлях Валерії пов’язаний із ветеринарною медициною та міжнародними проєктами, де вона здобула цінний досвід роботи за кордоном. Це загартувало її характер, навчило відповідальності та наполегливості.</br></br>Участь у конкурсі для Валерії — це не лише здійснення дитячої мрії, а й можливість показати, що сучасна жінка може поєднувати професіоналізм, материнство, силу й жіночність. Вона прагне надихнути інших вірити у свої мрії, адже здійснити їх ніколи не пізно.",
      story: "",
      // voteCount: 6,
      voteCount: 6,
      link: "https://send.monobank.ua/jar/ATog2te7k3",
    },
    // НІЖНА
    {
      id: 4,
      imageUrl: require("../assets/images/queens/2026_3/nizhna.png"),
      fullName: "",
      description:
        "Ніжна Юлія — лікар-стоматолог-ортодонт і косметолог із Дніпра, яка присвятила своє життя турботі про красу, здоров’я та впевненість людей. Вона переконана, що справжня краса народжується з гармонії, внутрішньої сили та любові до себе.</br></br>Юлія — щаслива мама двох дітей. Окрім професійної діяльності, захоплюється танцями, кінним спортом, лижами, подорожами, вивчає акторську майстерність і вільно володіє англійською мовою.</br></br>Поєднуючи жіночність, цілеспрямованість і прагнення до розвитку, Юлія впевнено йде до своїх мрій та надихає інших власним прикладом, демонструючи силу й красу сучасної української жінки.",
      story: "",
      // voteCount: 1,
      voteCount: 1 + 50,
      link: "https://send.monobank.ua/jar/74gPS8k9Y1",
    },
    // ПЛАХОТНИК
    {
      id: 5,
      imageUrl: require("../assets/images/queens/2026_3/plakhotnik.png"),
      fullName: "",
      description:
        "Валентина Плахотник — творча та цілеспрямована дівчина з Бахмута. Сьогодні вона розвивається у б’юті-сфері, допомагаючи жінкам підкреслювати природну красу, та успішно будує кар’єру професійної моделі.</br></br>Нині Валентина перебуває за кордоном, але активно займається волонтерством і підтримує Україну, спрямовуючи частину свого доходу на допомогу захисникам.</br></br>Її найбільше захоплення — мотоспорт, якому вона присвятила понад 11 років. Валентина переконана, що краса, саморозвиток і наполегливість допомагають втілювати найсміливіші мрії.",
      story: "",
      // voteCount: 59,
      voteCount: 59 + 6,
      link: "https://send.monobank.ua/jar/78C1qoeV9a",
    },
    // СМАЛЬ
    {
      id: 6,
      imageUrl: require("../assets/images/queens/2026_3/smal.png"),
      fullName: "",
      description:
        "Вікторія — творча, амбітна та цілеспрямована особистість. У свої 24 роки вона вже понад три роки професійно розвивається у моделінгу, бере участь у фотозйомках і співпрацює з фотографами, салонами краси та різними брендами.</br></br>Вона захоплюється співом, дизайном одягу, створенням образів, спортом, танцями, веде блог в Instagram і любить подорожувати. Активний спосіб життя та творчість допомагають їй постійно розвиватися й відкривати нові можливості.</br></br>Окрім модельної кар’єри, Вікторія має медичну освіту та проходить інтернатуру за спеціальністю «Дерматовенерологія», плануючи розвиватися у сфері косметології. Для неї краса — це гармонійне поєднання естетики та здоров’я.",
      story: "",
      // voteCount: 28,
      voteCount: 28 + 1,
      link: "https://send.monobank.ua/jar/7qkxL9uJ6h",
    },
    // КОВІНЬКО
    {
      id: 7,
      imageUrl: require("../assets/images/queens/2026_3/kovinko.png"),
      fullName: "",
      description:
        "Тетяна Ковінько — українська модель, телеведуча та журналістка. Фіналістка проєкту «Холостяк-3», володарка титулу Ms. Royal Queen та переможниця . Експертка з міжособистісних стосунків, активно займається медійною діяльністю, бере участь у телевізійних проєктах і міжнародних конкурсах краси.",
      story: "",
      // voteCount: 11,
      voteCount: 11,
      link: "https://send.monobank.ua/jar/68rPEneXzW",
    },
    //МОЗОЛЕВА
    {
      id: 8,
      imageUrl: require("../assets/images/queens/2026_3/mozoleva.png"),
      fullName: "",
      description:
        "Мозолева Христина — амбітна та цілеспрямована дівчина з Одеси, яка з дитинства розвивається у модельній сфері. Закінчила Одеський національний морський університет і постійно працює над саморозвитком.</br></br>Свій модельний шлях Христина розпочала ще в дитинстві, представляючи Україну на міжнародних конкурсах, де здобула головний титул. Згодом неодноразово ставала призеркою престижних конкурсів краси.</br></br>Окрім модельної кар’єри, у підлітковому віці успішно розвивала YouTube-канал, який зібрав понад 150 тисяч підписників. Сьогодні Христина продовжує вдосконалюватися, відкривати нові можливості та впевнено рухатися до нових досягнень.",
      story: "",
      // voteCount: 19,
      voteCount: 19 + 6,
      link: "https://send.monobank.ua/jar/8n5P7yS8or",
    },
    // НАУМЕНКО
    {
      id: 9,
      imageUrl: require("../assets/images/queens/2026_3/naumenko.png"),
      fullName: "",
      description:
        "Науменко Карина народилася та проживає в Чорноморську. Закінчила Одеський національний морський університет, здобувши вищу філологічну освіту та диплом магістра з відзнакою.</br></br>Вже 5 років навчає англійської дітей і дорослих. За цей час допомогла десяткам учнів з України, Європи та Америки досягти своїх цілей, поєднуючи у викладанні знання, творчість і любов до розвитку.</br></br>Поза роботою Карина захоплюється вокалом, танцями та художнім читанням. Закінчила музичну школу по класу фортепіано й була учасницею українського фольклорного хору в Німеччині.</br></br> Сьогодні участь у конкурсі для неї — це можливість реалізувати давню мрію, представити Україну, надихнути інших і довести, що сучасна українська жінка поєднує жіночність, інтелект, талант і силу духу.",
      story: "",
      // voteCount: 92,
      voteCount: 92 + 7,
      link: "https://send.monobank.ua/jar/7okbANNkiJ",
    },
    // ПАЛЯНІЧЕНКО
    {
      id: 10,
      imageUrl: require("../assets/images/queens/2026_3/palianichenko.png"),
      fullName: "",
      description:
        "Паляниченко Софія — українська модель, акторка, співачка, танцюристка та волонтерка.</br>З 2014 року разом із батьками активно допомагає українським військовим. За свою підтримку на фронті отримала теплий позивний «Сонечко» та стала першою дитиною — учасницею фестивалю «Пісні, народжені в АТО».</br>У fashion-індустрії Софія — володарка всіх престижних титулів асоціації WLBF, учасниця Тижнів моди в Парижі та Мілані. У 13 років стала першою дитиною, яка вийшла на дорослий показ, представляючи українських та іноземних дизайнерів.</br>Паралельно розвиває кар’єру професійної співачки та акторки, знімається у фільмах, серіалах і комерційних проєктах.",
      story: "",
      // voteCount: 11,
      voteCount: 11,
      link: "https://send.monobank.ua/jar/5y5tsh8zhu",
    },

    // // РОМАНИЦЯ
    // {
    //   id: 6,
    //   imageUrl: require("../assets/images/queens/2026_3/romanytsa.png"),
    //   fullName: "",
    //   description: "",
    //   story: "",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/AS46AdsGq2",
    // },
    // {
    //   id: 9,
    //   imageUrl: require("../assets/images/queens/2026_2/illashenko_v.png"),
    //   fullName: "",
    //   description:
    //     "",
    //   story: "",
    //   voteCount: 1,
    //   link: "https://send.monobank.ua/jar/r42HZt3p2",
    // },
    // {
    //   id: 8,
    //   imageUrl: require("../assets/images/queens/2026_2/birkivska_o.png"),
    //   fullName: "",
    //   description:
    //     "Особистість, яка уособлює силу слова, активну громадянську позицію та прагнення до справедливості. Ще зі шкільної парти Олена обрала шлях журналістики, формуючи в собі вміння бачити суть подій і доносити правду до людей. Вільне володіння англійською мовою відкрило для неї ширші горизонти комунікації та професійного розвитку на міжнародному рівні.<br>Як проєкт-менеджерка, вона вміло поєднує стратегічне мислення з організаційними навичками, створюючи ініціативи, що мають реальний вплив. Її діяльність як волонтерки та працівниці правозахисного сектору є свідченням глибокої відданості суспільству та щирого бажання допомагати тим, хто цього потребує.<br>Олена прагне розширити свої можливості у публічній діяльності, щоб ще ефективніше відстоювати права жінок та людей, які потребують правової підтримки. На конкурсі вона представляє образ сучасної української жінки — свідомої, сміливої, небайдужої, яка використовує свої знання та досвід задля змін у суспільстві.",
    //   story: "",
    //   voteCount: 49,
    //   link: "https://send.monobank.ua/jar/9RoYkxooyu",
    // },
    // {
    //   id: 2,
    //   imageUrl: require("../assets/images/queens/2026_2/tsapar_n.png"),
    //   fullName: "",
    //   description:
    //     "Особистість, яка втілює ідею постійного розвитку та гармонії. Жінка, яка на власному досвіді довела: справжні зміни починаються з внутрішньої сили характеру. Наталія пройшла шлях вражаючої особистої трансформації, втративши 30 кілограмів, що стало для неї не лише перемогою над тілом, а й відкриттям незламної віри у власні можливості.<br>Як авторка онлайн-курсу з покращення якості життя, вона допомагає іншим знайти шлях до здорових звичок та впевненості. Через творчість у TikTok та свій онлайн-магазин одягу Наталія транслює естетику самовираження, надихаючи тисячі людей залишатися собою та плекати індивідуальність.<br>Велике серце Наталії проявляється у турботі про тих, хто не може захистити себе сам — вона активно підтримує притулки для собак, вважаючи милосердя до тварин найвищим проявом людяності. На конкурсі вона прагне продемонструвати, що сучасна українська жінка — це поєднання залізної дисципліни, ніжної доброти та здатності надихати власним прикладом.",
    //   story: "",
    //   voteCount: 2,
    //   link: "https://send.monobank.ua/jar/9A3eQjSJy9",
    // },
    // {
    //   id: 3,
    //   imageUrl: require("../assets/images/queens/2026_2/bykova_j.png"),
    //   fullName: "",
    //   description:
    //     "Особистість, яка втілює гармонію краси, внутрішньої сили та жіночої впевненості. У свої 33 роки Юлія є прикладом сучасної жінки, яка майстерно поєднує професіоналізм і щире бажання допомагати іншим розкривати свою індивідуальність. Як стоматолог-ортодонт і косметолог, вона працює не лише з зовнішністю, а й з внутрішнім відчуттям людини — її самооцінкою, впевненістю та радістю бачити себе красивою. Юлія вірить у справжню красу — не ідеальну, а живу та унікальну.<br>Материнство займає особливе місце в її житті. Будучи мамою двох дітей, вона щодня надихається їхньою любов’ю та щирістю. Саме вони навчили її найважливішому — вірити, любити та залишатися сильною навіть у непрості моменти.<br>Її життя наповнене рухом і натхненням: танці, кінний спорт, лижі та подорожі допомагають їй відчувати свободу і гармонію. Водночас Юлія постійно розвивається — вивчає акторську майстерність, щоб глибше розуміти себе та сміливо проявляти свою особистість. Володіння англійською мовою відкриває для неї нові горизонти та можливості.<br>Юлія — ніжна, але сильна; м’яка, але цілеспрямована. Вона випромінює життєрадісність і вдячність за кожен прожитий момент. На конкурсі вона прагне показати, що сучасна українська жінка — це поєднання гідності, сили духу та природної краси, яку вона готова нести у світ.",
    //   story: "",
    //   voteCount: 9,
    //   link: "https://send.monobank.ua/jar/8makRZQSLd",
    // },
    // {
    //   id: 7,
    //   imageUrl: require("../assets/images/queens/2026_2/galabitska_m.png"),
    //   fullName: "",
    //   description:
    //     "Мене звати Марія Галабіцька. Мені 24 роки. Я - педагог і менеджер, і саме ці професії навчили мене не лише розуміти людей, а й надихати і вести за собою. Рік життя за кордоном допоміг мені усвідомити головне - моя справжня реалізація - в Україні. Саме тут я хочу розвиватись, будувати своє життя і надихати інших. Для мене цей конкурс - це не просто участь заради участі. Це новий рівень, який дасть змогу заявити про себе, відкрити нові горизонти заради великих звершень, розвитку та перемог.<br>І я впевнено крокую вперед, адже вірю - саме такі цінності, щирість і сила духу є справжнім втіленням королеви цього сезону.",
    //   story: "",
    //   voteCount: 2,
    //   link: "https://send.monobank.ua/jar/243a1EVyaQ",
    // },
    // {
    //   id: 1,
    //   imageUrl: require("../assets/images/queens/2026_2/kucherenko_n.png"),
    //   fullName: "",
    //   description:
    //     "Історія Наталії — це шлях квітки, що має силу прорости крізь найтвердіше каміння. Народившись у невеликому селі на Луганщині, вона змалку гартувала свою тендітну душу, перетворюючи кожне життєве випробування на внутрішню силу та незламність.<br>Сьогодні Наталія реалізує своє покликання у Дніпрі — місті, що стало для неї простором зростання. Як талановитий педагог, вона щодня дарує дітям тепло свого серця, а як любляча мама — виховує двох дітей, вбачаючи у материнстві найвище щастя. Її життя — це ідеальний баланс між професією, спортом та нескінченною жіночністю. Вона власним прикладом доводить: навіть у найскладніші часи жінка залишається джерелом світла, надихаючи інших своєю вірою в те, що краса та любов завжди перемагають.",
    //   story: "",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/YvCmEyfDN",
    // },
    // {
    //   id: 4,
    //   imageUrl: require("../assets/images/queens/2026_2/pavlishin_m.png"),
    //   fullName: "",
    //   description:
    //     "Особистість, яка поєднує в собі естетику, глибину та силу характеру. Архітекторка та дизайнерка інтер’єрів, яка разом зі своєю командою реалізувала понад 500 проєктів, створюючи простори, що стають відображенням внутрішнього світу людини та місцем її сили й натхнення.<br>Маріанна переконана: краса навколо безпосередньо впливає на внутрішній стан. Саме тому у своїх проєктах вона не просто формує інтер’єри, а створює атмосферу гармонії, затишку та естетичного балансу, де людина може відчувати себе собою.<br>Зараз Маріанна розвиває власний YouTube-канал, де ділиться знаннями про створення інтер’єрів, розкриває поняття інтер’єрної краси та навчає бачити стиль у деталях. Її мета — допомогти людям усвідомлено формувати простір, який підсилює їхню енергію та якість життя.<br>Окрім професійної діяльності, вона є художницею та організаторкою творчих вечорів, де люди через мистецтво відкривають себе, знайомляться та наповнюються новими сенсами.<br>Важливе місце в її житті займають спорт, йога та духовний розвиток. Маріанна вірить, що справжня краса народжується там, де поєднуються внутрішня глибина, емоційна наповненість та доглянутість зовнішнього образу.<br>На конкурсі Маріанна прагне показати, що сучасна жінка — це гармонія тіла, розуму й душі, здатність створювати красу навколо себе та надихати інших жити усвідомлено і в балансі.",
    //   story: "",
    //   voteCount: 24,
    //   link: "https://send.monobank.ua/jar/9DUb7Dhcmp",
    // },
    // {
    //   id: 6,
    //   imageUrl: require("../assets/images/queens/2026_2/small_v.png"),
    //   fullName: "",
    //   description:
    //     "Особистість, яка уособлює поєднання творчості, амбіційності та внутрішньої гармонії. У свої 24 роки Вікторія впевнено будує свій шлях у сфері краси та моди, вже понад три роки професійно розвиваючись у моделінгу. Вона бере участь у зйомках, співпрацює з фотографами, салонами краси та різними закладами, що дозволяє їй постійно відкривати нові грані своєї творчості та самовираження.<br>Її натхнення знаходить відображення у співі, створенні унікальних образів та дизайні одягу, які вона самостійно втілює, доповнюючи їх витонченим макіяжем і власним баченням стилю. Активний спосіб життя — спорт, танці, захоплення кіномистецтвом, ведення блогу в Instagram та любов до подорожей — формують її як сучасну, багатогранну особистість, яка впевнено почувається в індустрії краси.<br>Окрім творчого розвитку, Вікторія має медичну освіту за спеціальністю «Медицина» та наразі проходить інтернатуру за напрямком «Дерматовенерологія», плануючи подальший розвиток у сфері косметології. Для неї це не просто професія, а глибоке розуміння краси зсередини, що поєднує естетику та здоров’я.",
    //   story: "",
    //   voteCount: 9,
    //   link: "https://send.monobank.ua/jar/9Q4AxckgtV",
    // },
    // {
    //   id: 5,
    //   imageUrl: require("../assets/images/queens/2026_2/voitovich_o.png"),
    //   fullName: "",
    //   description:
    //     "Мисткиня та громадська діячка, чиє ім’я внесене до почесного списку «Відомі жінки України». Оксана Олександрівна — композиторка, скрипалька та поетеса, дворазова лауреатка премії «Найкраща українка в професії» (2024, 2025) та володарка титулу «Лідер року 2025».<br>Її діяльність — це унікальний синтез музики та оздоровлення. Будучи викладачем вищої категорії та сертифікованим краніосакральним терапевтом (USA), вона поєднує цілющу силу вібрацій із терапевтичними методиками для відновлення внутрішнього балансу людини. Творчий шлях Оксани відзначений медаллю «За служіння мистецтву» та публікаціями на обкладинках міжнародних видань, зокрема «Millennium Club».",
    //   story: "",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/21PtF9yuVT",
    // },
    // {
    //   id: 2,
    //   imageUrl: require("../assets/images/queens/2026/q102.png"),
    //   fullName: "",
    //   description:
    //     "Історія Крістіни — це шлях яскравих перемог та постійного пошуку нових горизонтів. Випускниця Одеського національного морського університету, вона з дитинства впевнено почувається у світі краси. Ще дитиною Крістіна гідно представила Україну на світовій арені, здобувши головний титул на престижному конкурсі Miss Universe Junior.<br>Її успіх продовжився і в дорослому моделінгу: у 2023 році вона стала володаркою титулу «Miss Black Sea» на конкурсі «Міс Одеса». Маючи досвід медійності та ведення великого блогу, сьогодні Крістіна зосереджена на внутрішньому зростанні. Вона присвячує свій час саморозвитку, вірячи, що справжня краса — це гармонія між зовнішніми досягненнями та постійним самовдосконаленням.",
    //   story: "",
    //   voteCount: 62,
    //   link: "https://send.monobank.ua/jar/98HNBEi7xr",
    // },
    // {
    //   id: 3,
    //   imageUrl: require("../assets/images/queens/2026/q103.png"),
    //   fullName: "",
    //   description: "",
    //   story:
    //     "Директор «Відпочинок без кордонів»<br>Успішна бізнес-леді, актриса та мандрівниця за покликанням. Валерія Барчан майстерно поєднує управління туристичною компанією з яскравою кар'єрою в кіно та рекламі. Її життя — це постійний рух, нові країни та нові ролі, де кожна подія стає джерелом натхнення.<br>Вона втілює образ сучасної жінки, яка не боїться виходити за межі звичного. Завдяки своїй енергійності та непохитній вірі в успіх, Валерія допомагає іншим відкривати горизонти, про які вони раніше лише мріяли. Її професіоналізм базується на власному досвіді підкорення вершин, а її кредо — «немає нічого неможливого» — звучить у кожному реалізованому проєкті.",
    //   voteCount: 329,
    //   link: "https://send.monobank.ua/jar/kVrebF9n8",
    // },
    // {
    //   id: 4,
    //   imageUrl: require("../assets/images/queens/2026/q104.png"),
    //   fullName: "",
    //   description:
    //     "Творча особистість, яка вміє перетворювати зміни на джерело сили. Пройшовши непростий шлях ВПО від рідного Донецька до затишного селища на Харківщині, Ірина відкрила в собі нові грані. Вона опановує мистецтво сільського життя, знаходячи спокій у роботі з землею та квітами.<br>Багатогранність Ірини вражає: вона створює картини, пише фанфіки за улюбленими всесвітами та вчиться підкорювати струни електрогітари. Її влог про естетику догляду за собою та творчі пошуки — це відображення її незламності та прагнення до краси. Ірина — приклад того, як можна почати спочатку і наповнити кожну мить глибоким змістом та творчою енергією.",
    //   story: "",
    //   voteCount: 2,
    //   link: "https://send.monobank.ua/jar/9vvFDX2bxS",
    // },
    // {
    //   id: 5,
    //   imageUrl: require("../assets/images/queens/2026/q105.png"),
    //   fullName: "",
    //   description: "",
    //   story:
    //     "Менеджер, мандрівниця та щаслива мама. Марина професійно реалізує себе у сфері продажів, використовуючи досконале знання англійської для підкорення нових вершин. Поза роботою її серце належить подорожам: за її плечима вже 20 країн, і це лише початок на шляху до великої навколосвітньої мрії.<br>Для Марини важливо залишатися вірною своїм принципам — добру та справедливості. Вона живе за правилом «тут і зараз», насолоджуючись кожною миттю у колі сім’ї та закликаючи людей бути добрішими одне до одного. Це образ сучасної жінки, яка гармонійно поєднує кар’єру, сімейний затишок та нестримну жагу до відкриттів.",
    //   voteCount: 24,
    //   link: "https://send.monobank.ua/jar/2893kxxN2a",
    // },
    // {
    //   id: 6,
    //   imageUrl: require("../assets/images/queens/2026/q106.png"),
    //   fullName: "",
    //   description: "",
    //   story:
    //     "Мама, жінка, яка щиро вірить у силу жіночності, внутрішню гармонію та постійний розвиток.<br><br>У повсякденному житті Ірина поєднує материнство, роботу та саморозвиток. Активно займається спортом і переконана, що турбота про своє тіло — це прояв любові та поваги до себе. Також працює у сфері TikTok-монетизації, створює контент і надихає свою аудиторію бути впевненими в собі та не боятися змін.<br><br>Особливе місце в її житті займає дитина, яку вона підтримує у світі спортивно-бальних танців. Ірина вірить, що справжня краса — це гармонійне поєднання зовнішньої привабливості, доброти серця та сили характеру.<br><br>Моя мета на конкурсі — не лише проявити себе, а й показати, що сучасна жінка може бути ніжною і сильною водночас. У майбутньому я мрію про щасливу родину, гармонійний розвиток і нові великі досягнення.",
    //   voteCount: 36,
    //   link: "https://send.monobank.ua/jar/9M8ExZVNuC",
    // },
    // {
    //   id: 7,
    //   imageUrl: require("../assets/images/queens/2026/q108.png"),
    //   fullName: "",
    //   description: "",
    //   story:
    //     "Підприємець в сфері ювелірних виробів, фотограф за покликом душі та помічник мами -виховательки дитячого будинку сімейного типу, сьогодні в нашій родині виховується 7 діток!<br>Це дуже відповідально і чудово коли збираємося всі разом!  <br>Професійна діяльність пов'язана з ювелірною сферою, бо  краса людини - її душа! <br><br>Незламність - це не просто вміння подолати важкості, але і воля не відступити, вона виявляється не лише в історії, але і в щоденному житті!",
    //   voteCount: 13,
    //   link: "https://send.monobank.ua/jar/7JDoAESGia",
    // },
    // {
    //   id: 8,
    //   imageUrl: require("../assets/images/queens/2026/q110.png"),
    //   fullName: "",
    //   description: "",
    //   story:
    //     "Історія Наталії — це шлях квітки, що має силу прорости крізь найтвердіше каміння. Народившись у невеликому селі на Луганщині, вона змалку гартувала свою тендітну душу, перетворюючи кожне життєве випробування на внутрішню силу та незламність.<br>Сьогодні Наталія реалізує своє покликання у Дніпрі — місті, що стало для неї простором зростання. Як талановитий педагог, вона щодня дарує дітям тепло свого серця, а як любляча мама — виховує двох дітей, вбачаючи у материнстві найвище щастя. Її життя — це ідеальний баланс між професією, спортом та нескінченною жіночністю. Вона власним прикладом доводить: навіть у найскладніші часи жінка залишається джерелом світла, надихаючи інших своєю вірою в те, що краса та любов завжди перемагають.",
    //   voteCount: 172,
    //   link: "https://send.monobank.ua/jar/9KNpkk5fQJ",
    // },
    // {
    //   id: 9,
    //   imageUrl: require("../assets/images/queens/2026/q111.png"),
    //   fullName: "",
    //   description: "",
    //   story:
    //     "Івент-координатор компанії Biopell, для якої організація заходів — це мистецтво поєднання структури та результату. Дар’я професійно керує процесами, від координації зйомок до вирішення найскладніших операційних запитів. Її підхід базується на швидкості, ефективності та вмінні тримати фокус на головному.<br>Окрім професійної сфери, вона активно розвиває свій голос, знаходячи натхнення у мистецтві озвучення. Це рідкісне поєднання менеджерської дисципліни та вокальної майстерності дозволяє Дар’ї створювати проєкти, які мають не лише форму, а й особливу енергію. Для неї кожен захід — це можливість довести, що чітка логіка та творче натхнення працюють найкраще в тандемі.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/8MqvCUr8AA",
    // },
    // {
    //   id: 10,
    //   imageUrl: require("../assets/images/queens/2026/q112.png"),
    //   fullName: "",
    //   description: "",
    //   story:
    //     "Творча особистість, яка перетворює кожен свій крок у мистецтво, а кожну подорож — у джерело глибокого сенсу. Для Ілони світ — це не просто географія, а нескінченна палітра культур, історій та емоцій, які вона вбирає в себе, щоб згодом втілити у нові образи.<br>Її життя — це безперервний рух: від відкриття нових горизонтів на карті до динамічного ритму танцю. Вона не просто спостерігає за красою світу, а активно її створює, надихаючи оточуючих своєю автентичністю та естетичним баченням.<br>Ілона переконана, що справжня творчість народжується на перетині особистого досвіду та світових вражень. Вона впевнено транслює свою візію, доводячи, що жити творчістю — це означає бути у гармонії зі світом і щодня відкривати в ньому щось величне.",
    //   voteCount: 1,
    //   link: "https://send.monobank.ua/jar/8kAcsmNqxZ",
    // },
    // {
    //   id: 11,
    //   imageUrl: require("../assets/images/queens/2026/q113.png"),
    //   fullName: "",
    //   description: "",
    //   story:
    //     "Особистість, яка вірить у силу характеру, щирість та незламність людського духу.<br>У повсякденному житті Ксенія втілює образ сучасної жінки, яка відкрита до світу та нових викликів. Вона має вагомий міжнародний досвід: робота в Індії та ОАЕ навчила її знаходити спільну мову з представниками різних культур та поважати багатогранність світу. Цей досвід сформував її як толерантну та комунікабельну особистість, здатну гідно представляти себе на будь-якому рівні.<br>Події останніх років докорінно змінили її світосприйняття. Війна навчила Ксенію ще більше цінувати людяність та взаємодопомогу. Вона переконана, що справжня краса — це не лише зовнішність, а гармонійне поєднання внутрішньої сили, доброти та впевненості в собі.<br>Моя мета на конкурсі — отримати платформу для того, щоб голос моєї країни звучав гучніше. Для мене цей титул — не про славу, а про можливість розповідати світові про Україну, її незламну націю та боротьбу за справедливість. Мрію гідно представити свою державу на міжнародній арені та використовувати власну силу для допомоги тим, хто цього потребує.",
    //   voteCount: 1,
    //   link: "https://send.monobank.ua/jar/8fVqkd6ENK",
    // },
    // {
    //   id: 12,
    //   imageUrl: require("../assets/images/queens/2026/q109.png"),
    //   fullName: "",
    //   description:
    //     "Експертка у сфері інвестицій, яка знає, як створювати можливості та досягати поставлених цілей. Життєвий простір Анни наповнений активністю: від чітких бізнес-стратегій до підкорення нових маршрутів у подорожах.<br>Її любов до природи та занять спортом — це не просто хобі, а філософія здорового та свідомого життя. Для Анни важливо не просто рухатися вперед, а робити це з відкритим серцем, знаходячи красу в кожному куточку планети та силу в кожному новому виклику.",
    //   story: "",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/21xLNXAjV7",
    // },
    // {
    //   id: 13,
    //   imageUrl: require("../assets/images/queens/2026/q114.png"),
    //   fullName: "",
    //   description:
    //     "Жінка, яка перетворює власну мрію на реальність, наповнюючи світ навколо себе магнетичною харизмою та справжньою жіночою енергією. Для Юлії життя — це мистецтво балансу, де морський прибій рідної Одеси дарує натхнення для реалізації найсміливіших амбіцій.<br>Її шлях — це гармонійне поєднання ніжності материнства та залізної витримки у професійній сфері будівництва. Вона не просто створює простір навколо себе, а закладає фундамент із любові, доброти та внутрішньої сили, вірячи, що щирість здатна трансформувати навколишній світ.<br>Юлія переконана, що найбільші перемоги починаються з подолання внутрішніх бар’єрів. Участь у конкурсі для неї — це омріяний крок у всесвіт краси та моди, смілива заява про себе серед творчих особистостей. Вона впевнено йде назустріч змінам, доводячи, що віра у власне призначення здатна відкрити двері у величне майбутнє.",
    //   story: "",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/yKSi6UKak",
    // },
    // {
    //   id: 14,
    //   imageUrl: require("../assets/images/queens/2026/q107.png"),
    //   fullName: "",
    //   description:
    //     "У минулому — бойовий медик із позивним «Сойка». За покликом серця пішла на фронт рятувати наших героїв, залишивши позаду роботу, здоров’я та особисте життя.<br>Сьогодні працює у сфері пластичної хірургії та є учасницею благодійного фонду, який організовує концерти для збору коштів на підтримку Збройних Сил України.<br>А ще Оксана щиро вірить, що кожна людина може нести у світ добро, радість і щастя.<br><br>Незламність — це не лише здатність долати труднощі, а й сила серця допомагати іншим, навіть у найважчі часи.",
    //   story: "",
    //   voteCount: 1,
    //   link: "https://send.monobank.ua/jar/7PUpm4xgs7",
    // },
    // {
    //   id: 15,
    //   imageUrl: require("../assets/images/queens/2026/q115.png"),
    //   fullName: "",
    //   description:
    //     "Мисткиня та громадська діячка, чиє ім’я внесене до почесного списку «Відомі жінки України». Оксана Олександрівна — композиторка, скрипалька та поетеса, дворазова лауреатка премії «Найкраща українка в професії» (2024, 2025) та володарка титулу «Лідер року 2025».<br>Її діяльність — це унікальний синтез музики та оздоровлення. Будучи викладачем вищої категорії та сертифікованим краніосакральним терапевтом (USA), вона поєднує цілющу силу вібрацій із терапевтичними методиками для відновлення внутрішнього балансу людини. Творчий шлях Оксани відзначений медаллю «За служіння мистецтву» та публікаціями на обкладинках міжнародних видань, зокрема «Millennium Club».",
    //   story: "",
    //   voteCount: 104,
    //   link: "https://send.monobank.ua/jar/cdmYkdAp5",
    // },
    // {
    //   id: 16,
    //   imageUrl: require("../assets/images/queens/2026/q116.png"),
    //   fullName: "",
    //   description:
    //     "Особистість, яка вірить у силу характеру та незламність людського духу. Щаслива дружина та мама, Настін присвятила себе місії повернення жінок до їхньої справжньої природи. Як авторка трансформаційних практик, вона допомагає іншим розкривати внутрішню силу та енергію життя.<br>Війна навчила її понад усе цінувати людяність. Для неї справжня краса — це гармонія доброти та впевненості. На конкурсі Настін прагне стати голосом української жінки: незламної, люблячої та сильної, здатної гідно представляти свою державу на міжнародній арені.<br>Кредо: Розкривати красу жінки через любов до себе та внутрішню силу.",
    //   story: "",
    //   voteCount: 388,
    //   link: "https://send.monobank.ua/jar/7kuKB1xWkM",
    // },
    // {
    //   id: 17,
    //   imageUrl: require("../assets/images/queens/2026/q117.png"),
    //   fullName: "",
    //   description:
    //     "Особистість, яка втілює ідею постійного розвитку та гармонії. Жінка, яка на власному досвіді довела: справжні зміни починаються з внутрішньої сили характеру. Наталія пройшла шлях вражаючої особистої трансформації, втративши 30 кілограмів, що стало для неї не лише перемогою над тілом, а й відкриттям незламної віри у власні можливості.<br>Як авторка онлайн-курсу з покращення якості життя, вона допомагає іншим знайти шлях до здорових звичок та впевненості. Через творчість у TikTok та свій онлайн-магазин одягу Наталія транслює естетику самовираження, надихаючи тисячі людей залишатися собою та плекати індивідуальність.<br>Велике серце Наталії проявляється у турботі про тих, хто не може захистити себе сам — вона активно підтримує притулки для собак, вважаючи милосердя до тварин найвищим проявом людяності. На конкурсі вона прагне продемонструвати, що сучасна українська жінка — це поєднання залізної дисципліни, ніжної доброти та здатності надихати власним прикладом.",
    //   story: "",
    //   voteCount: 533,
    //   link: "https://send.monobank.ua/jar/4rxPJz7Pji",
    // },
    // {
    //   id: 18,
    //   imageUrl: require("../assets/images/queens/2026/q118.png"),
    //   //imageUrl: require("../assets/images/lady.png"),
    //   fullName: "",
    //   description:
    //     "Особистість, яка втілює ідею нескінченної енергії та творчого пошуку. Жінка, яка на власному досвіді доводить: справжня реалізація не має часових меж, а кожен новий етап життя — це можливість для масштабного старту. Оксана перетворила багаторічне захоплення спортом на професійне покликання, здобувши кваліфікацію тренера та ставши справжнім мегамотиватором для тих, хто прагне змін.<br>Як сертифікована фахівчиня та генератор ідей, вона допомагає іншим віднайти віру у власні сили, керуючись принципом: «Діяти тут і зараз, щоб не шкодувати про згаяні можливості». Її шлях — це історія про незламну дисципліну та здатність завжди йти тільки вперед.<br>Творча натура Оксани розкривається у дизайні авторських аксесуарів, де кожен виріб стає маніфестом індивідуальності та креативу. Маючи досвід організації подібних заходів, вона сприймає конкурс як простір для обміну живою енергією та натхненням з однодумцями. На цій сцені Оксана прагне продемонструвати, що сучасна українська жінка — це гармонійне поєднання залізної волі, невичерпного оптимізму та здатності створювати красу в кожній деталі свого життя.",
    //   story: "",
    //   voteCount: 1,
    //   link: "https://send.monobank.ua/jar/8Cf2B4Kwnr",
    // },
    // {
    //   id: 16,
    //   imageUrl: require("../assets/images/queens/2026/q016.jpg"),
    //   fullName: "",
    //   description: "",
    //   story: "",
    //   voteCount: 0,
    //   link: "",
    // },
    // {
    //   id: 2,
    //   imageUrl: require("../assets/images/queens/q7/q2.jpg"),
    //   fullName: "Чекурда <br> Яна",
    //   description: "Дніпро",
    //   story:
    //     "Я вірю, що сила жінки розкривається в гармонії краси, таланту та натхнення. Саме тому я заснувала власну студію краси — простір, де дівчата можуть відчути впевненість у собі та побачити свою унікальність.<br>Музика — мова моєї душі. Я вже створила два авторські треки і не зупиняюся, адже спів для мене — це спосіб ділитися енергією зі світом і надихати інших.<br>Я люблю спорт і переконана, що тіло й дух повинні розвиватися разом. У 2021 році я закінчила школу модельного мистецтва, беру участь у показах, фотосесіях та рекламних проєктах.<br>Моє покликання — надихати, вести за собою й допомагати жінкам розквітати, адже справжня краса народжується там, де є любов до себе і віра у власну силу.",
    //   voteCount: 142,
    //   link: "https://send.monobank.ua/jar/4mTe9QD9P2",
    // },
    // {
    //   id: 3,
    //   imageUrl: require("../assets/images/queens/q7/q3.jpg"),
    //   fullName: "Гладкова Євгенія",
    //   description: "Харків",
    //   story:
    //     "Я — капітан поліції, старший дослідник та наймолодший доктор юридичних наук в Україні. Моя спеціалізація — кримінальне право та кримінологія.<br>Заступниця голови Вченої ради Харківського національного університету внутрішніх справ. Авторка понад 200 наукових праць та співавторка науково-практичного коментаря Закону України «Про Національну поліцію».<br>Але за сухими титулами є інше життя.<br>Я — співзасновниця благодійного фонду «Долоньки миру», який став моєю віддушиною. За два з половиною роки наша команда:<br>1.передала 3 автівки на ЗСУ;<br>2.евакуювала понад 100 родин;<br>3.відвідала понад 200 деокупованих сіл та селищ;<br>4.допомагала на Херсонщині після підриву Каховської ГЕС;<br>5.забезпечила одягом і взуттям рятівників Харківщини, Херсонщини, Запоріжжя, Сумщини та інших областей;<br>6.реалізувала понад 20 масштабних проєктів.<br>У спорті я — кандидат у майстри спорту з карате.<br>Маю три вищі освіти, зокрема психологічну, яку здобула вже під час повномасштабної війни, здійснивши свою давню мрію.<br>У мене є й зовсім інше захоплення — колекціонування ексклюзивних ляльок «Барбі». Це хобі з дитинства, яке нагадує: навіть у дорослому, складному житті важливо залишати місце для мрій.<br>Але головні мої ролі — донька, дружина та мама маленького сина.<br>Я — патріотка Харкова й України.<br>Моє життєве кредо просте, але водночас обов’язкове для мене:<br>«Знання зумовлюють відповідальність».",
    //   voteCount: 18,
    //   link: "https://send.monobank.ua/jar/4ipUUPwkZf",
    // },
    // {
    //   id: 4,
    //   imageUrl: require("../assets/images/queens/q7/q4.jpg"),
    //   fullName: "Коптенко Дар’я",
    //   description: "Львів",
    //   story:
    //     "Сміливо входжу в бʼюті-індустрію та мрію відкрити власну студію. Я відкрита, харизматична й легко знаходжу спільну мову з будь-ким — від консультанта у магазині до продавця на базарі.<br>У 17 років я залишила Харків і почала життя у Львові самостійно. Війна забрала частину мого світу, але не силу духу. 9 років сцени та всеукраїнські конкурси загартували мене, а друзі називають людиною, яка надихає і наповнює енергією.<br>Я психолог за освітою, вивчала психоаналіз, психотерапію та психосоматику. Вірю: справжнє зцілення починається зсередини.",
    //   voteCount: 46,
    //   link: "https://send.monobank.ua/jar/4pejC3scWo",
    // },
    // {
    //   id: 5,
    //   imageUrl: require("../assets/images/queens/q7/q5.jpg"),
    //   fullName: "Ястремська Євгенія",
    //   description: "Харків",
    //   story:
    //     "Мене звати Євгенія. Я народилась у мальовничому Канєві, але майже все життя прожила на Харківщині — землі, яка загартувала мій характер і подарувала мені справжнє відчуття дому. Я — донька військового льотчика, тож із дитинства в мені виховали такі риси, як дисципліна, відповідальність, внутрішня сила, повага до людей та здатність залишатися вірною своїм принципам у будь-яких життєвих обставинах.<br>Мій шлях освіти та професійного становлення різноманітний. Я маю три вищі освіти. Працювала у банківській сфері, здобула досвід у юриспруденції, і вже під час повномасштабної війни закінчила магістратуру зі спеціальності «Практична психологія». Саме психологічні знання допомогли мені опанувати власні емоції та підтримати своїх рідних у період складної адаптації. Сьогодні моє нове захоплення — вивчення нейромереж та сучасних технологій, які відкривають переді мною безмежний простір для розвитку.<br>Та найцінніше моє досягнення — моя родина. Я маю щастя бути дружиною того, хто є моєю гордістю, моєю опорою і моїм натхненням. Я вдячна донька своїх прекрасних батьків, і мама двох чудових донечок. <br>Я дуже люблю життя. У мене завжди присутній внутрішній драйв, жага розвитку і відкритість до нового. З дитинства я займалась своїм фізичним розвитком, і обожнюю плавати, танцювати, імпровізувати. Моя філософія проста: рух і любов до життя — це джерело енергії та гармонії.<br>Сьогодні я активно займаюся волонтерською діяльністю. Я є членом волонтерської групи імені Павла Островського у м. Харків, де ми працюємо безпосередньо для підтримки наших хлопців із ЗСУ. Також долучилась до Благодійного проєкту допомоги знедоленим пенсіонерам Чернівецької області і маю підопічну, та підтримую сім’ї, які опинилися у складному фінансовому становищі.<br>Я вірю, що сила жінки — у її здатності поєднувати ніжність і стійкість, любов і відповідальність, мудрість і прагнення до змін. Саме такою я прагну бути щодня — для своєї родини, для свого народу, для України.",
    //   voteCount: 360,
    //   link: "https://send.monobank.ua/jar/AWH1WtVTnU",
    // },
    // {
    //   id: 6,
    //   imageUrl: require("../assets/images/queens/q7/q6.jpg"),
    //   fullName: "Щуцька Діана",
    //   description: "Тернопіль",
    //   story:
    //     "Я — дипломований жіночий наставник та практик роботи з мисленням, тілесними процесами і цілительськими методиками.<br>Маю магістерську освіту, пройшла шлях від найманої роботи до створення власної справи. Сьогодні я — засновниця жіночих програм розвитку, керівниця своєї команди та наставниця для десятків українок, які вже змінили своє життя завдяки моїм програмам.<br>Я беру участь у міжнародному жіночому проєкті, знялася у рекламі, яка транслюватиметься на найбільших екранах світу, а також з’явилася на обкладинці європейського модного журналу.<br>Моя мета — щоб українські жінки ставали успішними, самодостатніми та впевненими у собі. Бо саме від сили жінки залежить сила нашої нації 🇺🇦.",
    //   voteCount: 25,
    //   link: "https://send.monobank.ua/jar/Ac1WYccZSz",
    // },
    // {
    //   id: 7,
    //   imageUrl: require("../assets/images/queens/q7/q7.jpg"),
    //   fullName: "Гузь <br> Вікторія",
    //   description: "Київ",
    //   story:
    //     "Я створюю красу, яка лікує душі.<br>Я маю дві вищі освіти — практичного психолога та соціального працівника.<br>Війна забрала в мене дім, але не забрала сили йти за мрією. Попри труднощі та відсутність підтримки, я обрала не здаватися, а здійснити те, чого прагнула все життя.<br>Моя мрія — створювати красу.<br>Сьогодні я — візажист. Для мене макіяж — це не лише про зовнішність, а про жіночність, внутрішню силу та віру в себе.<br>Освіта психолога допомагає мені бачити глибину та відкривати справжню красу кожної жінки. А моя робота візажиста — надавати цій красі форму й дозволяти світу її побачити.<br>Окрім цього, я займаюся благодійністю, адже вірю: допомагати та проявлятися для інших — це найбільший дар і шанс залишити по собі добрий слід.<br>Моє покликання — надихати жінок відчувати себе особливими, підтримувати їх та допомагати сяяти навіть у найскладніші часи.",
    //   voteCount: 93,
    //   link: "https://send.monobank.ua/jar/5CNCyijR2N",
    // },
    // {
    //   id: 8,
    //   imageUrl: require("../assets/images/queens/q7/q8.jpg"),
    //   fullName: "Кожухар Надія",
    //   description: "Київ",
    //   story:
    //     "Я — Надія, народилась у Маріуполі. Веду свій блог, де надихаю жінок жити далі та показую, що навіть після важких втрат можна обирати щастя і будувати життя, сповнене любові. Також я працюю як UGC-creator, допомагаючи брендам передавати справжні емоції через контент.<br>На жаль, війна забрала у мене найдорожче — коханого чоловіка і рідний дім. Але сьогодні я перетворюю свій біль на силу: беру участь у благодійних проєктах, допомагаю військовим і ветеранам, надихаючи інших не здаватися.<br>З дитинства я пов’язана з мистецтвом: з 5 років професійно займалася танцями, навчалася на акторському факультеті та здобула освіту режисера драматичного театру і кіно. Це навчило мене бачити красу в деталях і передавати її іншим.<br>Моя місія — довести, що справжня краса жінки у її внутрішній силі, патріотизмі та здатності нести світло іншим.",
    //   voteCount: 47,
    //   link: "https://send.monobank.ua/jar/7anpYGFj5s",
    // },
    // {
    //   id: 9,
    //   imageUrl: require("../assets/images/queens/q7/q9.jpg"),
    //   fullName: "Ольга Цуркан",
    //   description: "Одеса",
    //   story:
    //     "Я — та, хто обрав шлях служіння світлу. Моє покликання — допомагати людям очищати енергію, зцілювати душу та відновлювати гармонію. Я вірю, що справжнє зцілення починається всередині кожного з нас, а моя місія — допомогти людині почути себе і знайти цей шлях.<br>Ангели завжди поруч, вони ніжно ведуть нас крізь випробування. Через ангелотерапію я дарую відчуття їхньої любові й підтримки, допомагаю побачити знаки Всесвіту, довіритися світлу та відкритися новим можливостям.<br>Моя робота — це не лише практика, а й глибокий внутрішній поклик: бути провідником між небом і землею, щоб кожна душа змогла відчути себе цілісною, захищеною та наповненою світлом.",
    //   voteCount: 17,
    //   link: "https://send.monobank.ua/jar/7aFVfVvweB",
    // },
    // {
    //   id: 10,
    //   imageUrl: require("../assets/images/queens/q7/q10.jpg"),
    //   fullName: "Ремньова Анастасія",
    //   description: "Дніпро",
    //   story:
    //     "Я — молода грумерка, яка обожнює свою справу та вміє перетворювати будь-якого пухнастика на справжню зірку.<br>Мої головні інструменти — ножиці, машинка та море любові до тварин.<br>Я знаю, як знайти підхід навіть до найвпертішого хвостика, бо для мене важливо, щоб кожен улюбленець виглядав гарно та почувався комфортно.<br>Люблю життя, швидкі рішення, аромат свіжої кави та щасливі мордочки після стрижки. І вірю: якщо тварини щасливі — щасливі й їхні господарі.",
    //   voteCount: 5,
    //   link: "https://send.monobank.ua/jar/AGJNRUqrbk",
    // },
    // {
    //   id: 11,
    //   imageUrl: require("../assets/images/queens/q7/q11.jpg"),
    //   fullName: "Желєзко Тетяна",
    //   description: "Кривий Ріг",
    //   story:
    //     "Я — людина, яка не зупиняється ні на мить. Маю три вищі освіти: викладач психології, дефектолог-логопед з інклюзивної освіти та юрист. Це дозволяє мені бачити світ з різних точок зору — розуміти психологію людей, підтримувати тих, хто потребує особливого підходу, та відстоювати справедливість.<br>Зараз я запускаю власний бренд косметики для відновлення волосся. Для мене це більше, ніж просто догляд. Це про турботу, природність і впевненість у собі. Це мій шлях поєднати силу та красу в одному продукті.<br>Я — творча і водночас сильна. Люблю співати, писати вірші, але так само із захопленням займаюся тайським боксом, легко беру в руки зброю і впевнено граю у футбол, волейбол та баскетбол. Спорт для мене — це енергія, свобода і баланс.<br>У мені живе поєднання жіночності й сили, творчості й дисципліни. Моє кредо просте: ніколи не зупинятися й завжди йти вперед.",
    //   voteCount: 224,
    //   link: "https://send.monobank.ua/jar/8epR5r9sB7",
    // },
    // {
    //   id: 12,
    //   imageUrl: require("../assets/images/queens/q7/q12.jpg"),
    //   fullName: "Жигалко Світлана",
    //   description: "Миколаїв",
    //   story:
    //     "Я здобула диплом перекладача в Чорноморському державному університеті імені Петра Могили. З дитинства мене манили нові знання й бажання пізнавати світ. Вільно володію німецькою та англійською, розмовляю іспанською та італійською, а ще вчила турецьку й албанську. За моїми плечима — подорожі до 93 країн світу, життя в Німеччині, Австрії, Туреччині та Албанії. Але серце завжди повертається в Україну. Моє особливе місце сили — Одеса.<br>Після університету я викладала іноземні мови, працювала перекладачем, а згодом наважилася на авантюру — вийти в море й спробувати життя на круїзному лайнері. Сьогодні ж моя стихія — стиль. Я працюю як стиліст-типажист і допомагаю жінкам відкрити не тільки свою красу, а й упевненість у собі. Бо я переконана: коли жінка закохана у власне відображення в дзеркалі — вона здатна на все.<br>Мене надихає робота з архетипами — як із ключем до проявлення себе у світі через одяг, рухи, спосіб подачі.<br>Моє послання для кожної жінки: ви вже цінні, сильні й прекрасні. Я лише допомагаю вам це побачити.",
    //   voteCount: 28,
    //   link: "https://send.monobank.ua/jar/JXArcVDvA",
    // },
    // {
    //   id: 13,
    //   imageUrl: require("../assets/images/queens/q7/q13.jpg"),
    //   fullName: "Кутузова Сніжана",
    //   description: "Мукачево",
    //   story:
    //     "Мене звати Сніжана. Я народилася у мальовничому містечку Мукачево, а нині проживаю в Чехії. Я щаслива мама двох дітей — донечки 12 років та синочка 7 років.<br>За освітою я провізор-фармацевт, закінчила Тернопільський медичний університет та працювала в аптеці. Проте життя відкрило для мене нові горизонти, і зараз я активно здобуваю знання у сфері косметології, зокрема в напрямках біоревіталізації та ліполіфтингу. Це дозволяє мені розвиватися, вдосконалюватися та реалізовувати власні мрії.<br>З дитинства я вірила, що справжня королева — це не титул і не корона, а внутрішня сила, впевненість та здатність надихати інших. Саме тому я вирішила взяти участь у конкурсі Charity Queen of Ukraine. Для мене це не просто конкурс краси, а можливість розкрити свій потенціал, вдосконалитися і здійснити давню мрію.<br>Я люблю подорожувати, займатися спортом і відкривати для себе нові можливості.<br>Моє життєве кредо: «Ніколи не зупинятися на досягнутому і завжди вірити в силу мрії».",
    //   voteCount: 103,
    //   link: "https://send.monobank.ua/jar/77NkqWNTtD",
    // },
    // {
    //   id: 1,
    //   imageUrl: require("../assets/images/queens/q6/001.jpg"),
    //   fullName: "Владилена Євжик",
    //   description: "Київ",
    //   story:
    //     "З чотирьох років професійно займаюся танцями і маю чимало призових місць на чемпіонатах міжнародного рівня. <br> Знімалася у серіалах «Слід» та «Сліпа», понад три роки працювала телеведучою на каналі «Новий Чернігів». Маю вищу юридичну освіту, закінчила Київську кіношколу, курси каскадерства, сценічного бою та навчалася у режисера Сергія Саніна.<br> Також захоплююся малюванням, психологією, верховою їздою та поезією.<br> Моя мета — наповнювати світ красою і творчістю, адже вірю, що в такі непрості часи люди повинні ділитися світлом і натхненням одне з одним, щоб кожен міг віднайти друге дихання для руху вперед.",
    //   voteCount: 4,
    //   link: "https://send.monobank.ua/jar/9BbGYRiKPY",
    // },
    // {
    //   id: 2,
    //   imageUrl: require("../assets/images/queens/q6/002.jpg"),
    //   fullName: "Діана Щуцька",
    //   description: "Тернопіль",
    //   story:
    //     "Я — дипломований жіночий наставник. <br> Власним прикладом доводжу, що кожна жінка може стати тією, якою хоче бути. <br> Я збираю найдієвіші методики з усього світу та передаю їх вам. Моя місія — щоб кожна українка була успішною, заможною та щасливою. Адже саме жінка є берегинею роду, і від її стану залежить сила нації! <br> Я — практик у роботі з мисленням, цілительських методик і тілесних процесів. <br> Маю магістерську освіту, пройшла шлях від найманої працівниці до власниці успішної справи та визнаного експерта у «м’якій» ніші, збудувала команду та стала наставником для інших. <br> Я беру участь у міжнародному жіночому проєкті. Уже знялася для реклами, яка буде демонструватися на найбільших екранах світу. Моє фото прикрашало обкладинку європейського модного журналу. І все це стало можливим завдяки тому, що я наважилася проявитися у своїй силі та таланті. <br> Тепер я надихаю інших жінок не боятися, а відкриватися новим можливостям у своєму житті!",
    //   voteCount: 645,
    //   link: "https://send.monobank.ua/jar/9D2o3Cxdvs",
    // },
    // {
    //   id: 3,
    //   imageUrl: require("../assets/images/queens/q6/003.jpg"),
    //   fullName: "Катерина Віхлічева",
    //   description: "Одеса",
    //   story:
    //     "Я Майстер з перманентного макіяжу, міні-тату, нарощування та ламінування вій, моделювання та фарбування брів.<br> Про себе<br> Я — майстер з понад 6річним досвідом у сфері б’юті-індустрії. Моя головна мета — підкреслювати природну красу кожної жінки, дарувати впевненість і гармонію. Постійно навчаюсь, відвідую професійні курси та майстер-класи, щоб працювати за найновішими техніками та з найкращими матеріалами.<br> Засновниця б’юті-студії “BeautyArt by K.Vikhlicheva” в м.Одеса<br>  Місія<br> Моя робота — це не лише про зовнішність, а й про внутрішній стан жінки. Вірю, що краса починається з турботи про себе та любові до власної індивідуальності.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/2pJcdDoHDb",
    // },
    // {
    //   id: 4,
    //   imageUrl: require("../assets/images/queens/q6/004.jpg"),
    //   fullName: "Анна Заболотня",
    //   description: "Київ",
    //   story:
    //     "Підприємець у сфері б'юті-індустрії<br> Я жінка, яка вірить, що краса починається зсередини. Вже кілька років розвиваю власну справу в індустрії краси, поєднуючи підприємництво з активним способом життя та материнством.<br> Я щаслива мати чудового сина — йому 3роки.<br> Мої захоплення - теніс, танці, читання та подорожі. Я обожнюю впізнавати нове, рости і розвиватися як особистість. Зараз вивчаю коучинг і прагну стати професіоналом у цій галузі, щоб допомагати людям розкривати їхній внутрішній потенціал.<br> У житті я особливо ціную дружбу, щирість та справжні людські цінності. Вірю, що зовнішня краса – це віддзеркалення внутрішнього світу",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/9ks3tLwhN2",
    // },
    // {
    //   id: 5,
    //   imageUrl: require("../assets/images/queens/q6/005.jpg"),
    //   fullName: "Анна Лукач",
    //   description: "Ужгород",
    //   story:
    //     "власниця студії з видалення тату та татуажу “SENATOR LASER”. <br> Рятую шкіру, нерви і репутацію.<br> Тату я видаляю лазером, але влучати в ціль — моя природна здатність. Маю бізнес, харизму і почуття гумору, яке може бути трішки небезпечним. Люблю життя, швидкі рішення, міцну каву і маю непереборне бажання жити та кайфувати від цього! А також мама трьох чарівних діток.",
    //   voteCount: 17,
    //   link: "https://send.monobank.ua/jar/49gSTa1r9i",
    // },
    // {
    //   id: 6,
    //   imageUrl: require("../assets/images/queens/q6/006.png"),
    //   fullName: "Daria Lyalina",
    //   description: "Київ",
    //   story:
    //     "Я — переможниця проєкту «Супер мама» на СТБ та лауреат премії ТОП-10 фотографів України 2024 року. Я білявка з блакитними очима, і це моя особлива візитівка.<br>Я вже 13 років працюю фотографом — це справа мого життя. Я знаю, як повинна виглядати жінка, щоб відчувати себе розкішною. Працюю по обидва боки об’єктива: і як фотограф, і як модель. Саме тому у своєму блозі я показую, що кожна з нас унікальна, і надихаю жінок розвиватися, досягати і, найголовніше, любити себе.<br>На конкурсі краси я хочу донести, що вмію нести красу у цей світ і заряджати нею інших. Моя місія — допомогти кожній дівчині повірити у себе та розквітнути.",
    //   voteCount: 115,
    //   link: "https://send.monobank.ua/jar/67X1XYdjju",
    // },
    // {
    //   id: 7,
    //   imageUrl: require("../assets/images/queens/q6/007.jpg"),
    //   fullName: "Філіпчук Вікторія",
    //   description: "Мукачево",
    //   story: "",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/7n52hircnF",
    // },
    // {
    //   id: 8,
    //   imageUrl: require("../assets/images/queens/q6/008.jpg"),
    //   fullName: "Ремньова Анастасія",
    //   description: "Дніпро",
    //   story:
    //     "Я — молода грумерка, яка обожнює свою справу та вміє перетворювати будь-якого пухнастика на справжню зірку.<br>Мої головні інструменти — ножиці, машинка та море любові до тварин.<br>Я знаю, як знайти підхід навіть до найвпертішого хвостика, бо для мене важливо, щоб кожен улюбленець виглядав гарно та почувався комфортно.<br>Люблю життя, швидкі рішення, аромат свіжої кави та щасливі мордочки після стрижки. І вірю: якщо тварини щасливі — щасливі й їхні господарі.",
    //   voteCount: 1001,
    //   link: "https://send.monobank.ua/jar/5tpCdFijvX",
    // },
    // {
    //   id: 9,
    //   imageUrl: require("../assets/images/queens/q6/009.png"),
    //   fullName: "Аліна Цімболинець",
    //   description: "Чернігів",
    //   story:
    //     "Я професійний візажист, топ beauty-майстер та beauty-контент-кріейтор, закохана в естетику та мистецтво перетворень. Вірю, що справжня краса це поєднання внутрішнього світла, гармонії та натхнення, яким ми ділимося з іншими.<br>Я розвиваю власний бренд, створюю освітні курси та проєкти для дівчат, організовую жіночі івенти та показую власним прикладом, що можливо досягти будь-якої мрії. Працюю з відомими брендами, розвиваюсь як UGC-кріейтор, створюю креативні відео та контент, який надихає.<br>Веду активний спосіб життя: займаюсь спортом, танцями, малюванням, розвиваю мислення та внутрішню енергію, якою прагну ділитися з оточенням. Моя мета надихати жінок вірити у себе, відчувати свою цінність та сміливо йти вперед.",
    //   voteCount: 4,
    //   link: "https://send.monobank.ua/jar/3C2ux5uemj",
    // },
    // {
    //   id: 10,
    //   imageUrl: require("../assets/images/queens/q6/010.jpeg"),
    //   fullName: "Надія Кожухар",
    //   description: "Київ",
    //   story:
    //     "Я блогерка та UGC-creator, надихаю жінок обирати щастя навіть після втрат і допомагаю брендам передавати справжні емоції через контент. Війна забрала в мене чоловіка і дім, але я перетворила біль на силу: беру участь у благодійних проєктах, підтримую військових і ветеранів.<br>З дитинства пов’язана з мистецтвом: професійні танці, акторська майстерність, режисура театру і кіно навчили мене бачити красу в деталях і передавати її іншим.<br>Моя місія — довести, що справжня краса жінки у внутрішній силі, патріотизмі та здатності нести світло іншим.",
    //   voteCount: 978,
    //   link: "https://send.monobank.ua/jar/4shos6zmoR",
    // },
    // {
    //   id: 2,
    //   imageUrl: require("../assets/images/queens/q202.jpg"),
    //   fullName: "Марина Швець",
    //   description: "Харків",
    //   story:
    //     "Моя місія — поширювати добро на Землі та запалювати внутрішнє світло в людях.<br>Я маю вищу освіту в галузі бізнесу та психології, вільно спілкуюсь 4 мовами, захоплююсь вокалом, спортом, духовним розвитком, скрипкою, танцем, подорожами, йогою й поєдную в собі декілька ролей.<br>Як жіночий коуч (Марина First)— допомагаю жінкам згадати про нашу силу, що полягає в любові та доброті, та побудувати щасливі стосунки.<br>Як викладач танцю бачата — об’єдную людей через розкриття себе, спорт, творчість та спілкування.<br>Мрію створити надійний благодійний фонд, щоб люди могли бути впевнені у його прозорості та честності.<br>Для мене справжня краса - це не форма, а зміст: тепло серця, щирість та доброта.<br>Вірю, що завжди варто зберігати внутрішнє світло, яке освітлює шлях нам і тим, хто навколо.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/9KKAiDrnab",
    // },
    // {
    //   id: 3,
    //   imageUrl: require("../assets/images/queens/q203.jpg"),
    //   fullName: "Юлія Сачан",
    //   description: "Львів",
    //   story:
    //     "Вища юридична освіта,на даний час працюю юристом в державній службі.<br>Люблю спорт, фотографію, подорожі, гори, спа та гольф. Вірю в силу моменту «тут і зараз» — життя не варто відкладати. Завжди мріяла про участь у конкурсі краси, і рада, що наважилась: це новий досвід, емоції та крок до впевненості в собі.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/AMNwzmxk49",
    // },
    // {
    //   id: 4,
    //   imageUrl: require("../assets/images/queens/q204.jpeg"),
    //   fullName: "Деревʼянко Діана",
    //   description: "Кременчук",
    //   story:
    //     "Я не граю за правилами — я створюю свої.<br>Кременчук, де я народилася, навчив мріяти.<br>Київ, де живу зараз, — не здаватися.<br>Італія, де я прожила рік, — бути собою, навіть коли весь світ інший.<br>Я — візажистка, майстриня, що працює з красою, але для мене це завжди щось більше, ніж зовнішнє. Це - про внутрішнє світло.<br>Разом із подругою маю свій бʼюті-коворкінг, де немає “треба” — є “як хочеш ти”.<br>Я йду в “Charity Queen of Ukraine”, бо мені є що сказати. Бо справжня краса — це не образ. Це вибір. Це дія. Це коли ти не чекаєш моменту — а сама стаєш ним.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/2wxwpE7H66",
    // },
    // {
    //   id: 6,
    //   imageUrl: require("../assets/images/queens/q205.jpg"),
    //   fullName: "Єлизавета Громенко",
    //   description: "Сєвєродонецьк",
    //   story:
    //     "Нині живу в Києві, де навчаюсь в університеті. Захоплююсь танцями, кінним спортом, тенісом, історією та благодійністю.<br> Вірю, що кожен день — шанс розкрити себе. Моя мрія з дитинства — показати, що краса — це гармонія душі, розуму й добрих вчинків.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/A2FZqtHtVq",
    // },
    // {
    //   id: 7,
    //   imageUrl: require("../assets/images/queens/q206.jpg"),
    //   fullName: "Христина Петренко",
    //   description: "Запоріжжя",
    //   story:
    //     "Танці — мій спосіб вираження, свободи й сили, моя медитація.<br>Кожне тренування — крок до себе: м’якої, жіночної, але впевненої й цілеспрямованої.<br>Я вчуся бачити красу в деталях і бути вдячною за свій шлях.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/78q2hBs2ue",
    // },
    // {
    //   id: 8,
    //   imageUrl: require("../assets/images/queens/q207.jpg"),
    //   fullName: "Надія Сандак",
    //   description: "Київ",
    //   story:
    //     "Люблю активний спосіб життя — бадмінтон і теніс. Працюю майстром із нарощення волосся, допомагаючи дівчатам відчувати себе красивими.<br>Моє кредо: «Краса починається з гармонії всередині». Вірю, що щаслива людина завжди випромінює світло.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/9CxfNaNDL8",
    // },
    // {
    //   id: 8,
    //   imageUrl: require("../assets/images/queens/q209.jpg"),
    //   fullName: "Аліна Сидельник",
    //   description: "Донеччина",
    //   story:
    //     "нині живу у Вінниці, куди переїхала три роки тому. Маю вищу педагогічну освіту, захоплююсь танцями та веду активний спосіб життя.<br>Для мене краса — це не про зовнішність, а про внутрішнє світло й готовність змінюватися. Адже справжня корона — всередині нас. Моє кредо: «Краще пожалкувати про те, що зробив, ніж про те, чого не наважився».",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/5VwWnq4s1a",
    // },
    // {
    //   id: 8,
    //   imageUrl: require("../assets/images/queens/q208.jpg"),
    //   fullName: "Анастасія Стасюк",
    //   description: "Чернівці",
    //   story:
    //     "Я людина, що обожнює життя у всіх його проявах — від екскурсій у підземелля до гірських походів, від малювання й скульптури до співів і танців. Моє кредо — «Зараз або ніколи».<br>Участь у цьому конкурсі — моя давня мрія, і саме час її здійснити. Хочу власним прикладом показати: не чекайте ідеального моменту — дійте, навіть якщо сумніваєтесь у собі.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/418JuQXrMj",
    // },
    // {
    //   id: 9,
    //   imageUrl: require("../assets/images/queens/q210.jpg"),
    //   fullName: "Ольга Селявіна",
    //   description: "Донецьк",
    //   story:
    //     "Я — людина справи, яка понад 15 років присвятила себе готельно-ресторанній сфері. Керуючи власним готелем, я навчилась не лише організовувати комфорт і сервіс, а й бачити в деталях душу гостинності.<br>Готування — моє особливе натхнення. Люблю створювати смаки, а особливо — випікати хліб, що наповнює дім теплом.<br>Зараз я працюю над новими проєктами готельного комплексу й мрію втілити їх після повернення у своє місто.<br>Для мене участь у цьому конкурсі — це не просто виклик, а можливість поділитись досвідом і почати нову сторінку професійного зростання.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/3xnUM9edoU",
    // },
    // {
    //   id: 3,
    //   imageUrl: require("../assets/images/queens/q3.jpg"),
    //   fullName: "Неборак Владислава",
    //   description: "Кременчук",
    //   voteCount: 709,
    //   link: "https://send.monobank.ua/jar/RXkVL5z9o",
    // },
    // {
    //   id: 4,
    //   imageUrl: require("../assets/images/queens/q4.jpg"),
    //   fullName: "Денисюк Галина",
    //   description: "Умань",
    //   voteCount: 3673,
    //   link: "https://send.monobank.ua/jar/8ghy5W3nVS",
    // },
    // {
    //   id: 5,
    //   imageUrl: require("../assets/images/queens/q5.jpg"),
    //   fullName: "Тереховська Анастасія",
    //   description: "Харків",
    //   voteCount: 1582,
    //   link: "https://send.monobank.ua/jar/9i9zEajLhb",
    // },
    // {
    //   id: 2,
    //   imageUrl: require("../assets/images/queens/q2.jpg"),
    //   fullName: "Тупичак Маріанна",
    //   description: "Львів",
    //   voteCount: 2559,
    //   link: "https://send.monobank.ua/jar/8c56ZNj8AF",
    // },
    // {
    //   id: 6,
    //   imageUrl: require("../assets/images/queens/q6.jpg"),
    //   fullName: "Темчинська Олександра",
    //   description: "Київ",
    //   voteCount: 51,
    //   link: "https://send.monobank.ua/jar/527oV1Zsq6",
    // },
    // {
    //   id: 7,
    //   imageUrl: require("../assets/images/queens/q7.jpg"),
    //   fullName: "Кулікова Лідія",
    //   description: "Одеса",
    //   voteCount: 110,
    //   link: "https://send.monobank.ua/jar/4viqJfpnZP",
    // },
    // {
    //   id: 8,
    //   imageUrl: require("../assets/images/queens/q13.jpg"),
    //   fullName: "Романенко Рімма",
    //   description: "Київ",
    //   voteCount: 11,
    //   link: "https://send.monobank.ua/jar/5j6757Z4iC",
    // },
    // {
    //   id: 9,
    //   imageUrl: require("../assets/images/queens/q9.jpg"),
    //   fullName: "Чистякова Наталі",
    //   description: "Одеса",
    //   voteCount: 76,
    //   link: "https://send.monobank.ua/jar/5Dnq6qCzji",
    // },
    // {
    //   id: 10,
    //   imageUrl: require("../assets/images/queens/q10.jpg"),
    //   fullName: "Саїнчук Ольга",
    //   description: "Київ",
    //   voteCount: 2507,
    //   link: "https://send.monobank.ua/jar/2YaSQgi8tV",
    // },
    // {
    //   id: 11,
    //   imageUrl: require("../assets/images/queens/q11.jpg"),
    //   fullName: "Плахотнюк Валентина",
    //   description: "Бахмут",
    //   voteCount: 902,
    //   link: "https://send.monobank.ua/jar/8HexLQd3kb",
    // },
    // {
    //   id: 12,
    //   imageUrl: require("../assets/images/queens/q12.jpg"),
    //   fullName: "Чернюк Олена",
    //   description: "Київ",
    //   voteCount: 332,
    //   link: "https://send.monobank.ua/jar/4jj2TniSYz",
    // },
    // {
    //   id: 14,
    //   imageUrl: require("../assets/images/queens/q14.png"),
    //   fullName: "Беломістна Наталія",
    //   description: "Харків",
    //   voteCount: 315,
    //   link: "https://send.monobank.ua/jar/7dK8VFUb3P",
    // },
    // {
    //   id: 14,
    //   imageUrl: require("../assets/images/queens/q15.jpg"),
    //   fullName: "Удовік Віталіна",
    //   description: "Київ",
    //   voteCount: 2444,
    //   link: "https://send.monobank.ua/jar/32rDJqrrwL",
    // },
    // {
    //   id: 14,
    //   imageUrl: require("../assets/images/queens/q16.jpg"),
    //   fullName: "Братіцел Василина",
    //   description: "Одеса",
    //   voteCount: 5,
    //   link: "https://send.monobank.ua/jar/2KL9xYK8xg",
    // },
    // {
    //   id: 2,
    //   imageUrl: require("../assets/images/queens/2.jpg"),
    //   fullName: "Сабріна Караушу",
    //   description:
    //     "Вітаю, мене звати Сабріна , мені 19 років, я живу в місті Чернівці.<br/>\nЯ студентка Юридичного інституту.<br/>\nВільний час проходить на самореалізацію. <br/>\nПрагну допомогти нашим захисникам України які воюють за наше майбутнє і за спокій в нашій країні. <br/>\nЯкщо проблема стала на моєму шляху як гора посеред дороги, то я шукаю обходи, інші дороги або взагалі міняю маршрут. Головне – це мета, тільки наявність мети приносить життя сенс і задоволення. Це сприяє не тільки поліпшенню здоров’я і довголіття, але також дає нам  крапельку оптимізму у важкий час. <br/>\nСлава нашим захисникам України!!!",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/8TFyr635aj",
    // },
    // {
    //   id: 3,
    //   imageUrl: require("../assets/images/queens/3.png"),
    //   fullName: "Олена Ковальова",
    //   description:
    //     "Я українка! Я добра,чуйна і вродлива. До перемоги прагну через перешкоди. Хочу допогти нашим героям,хоробрим хлопцям! Довести всім,що перемоги варта кожна! Я прагну досягти успіху і бути прикладом для всіх!",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/2XMtVajPmo",
    // },
    // {
    //   id: 4,
    //   imageUrl: require("../assets/images/queens/4.jpg"),
    //   fullName: "Аліна Тихенко",
    //   description:
    //     "Привіт,мене звати Аліна!<br/>\nЯ родом із Сумської області,на даний момент проживаю в місті Костопіль.<br/>\nМені 25 років.<br/>\nЧому хочу прийняти участь?<br/>\nТому що хочу показати,що навіть у такі тяжкі часи як зараз,українки сильні та незламні.<br/>\nСлава Україні!",
    //   voteCount: 220,
    //   link: "https://send.monobank.ua/jar/9X5XizEP6L",
    // },
    // {
    //   id: 5,
    //   imageUrl: require("../assets/images/queens/5.jpg"),
    //   fullName: "Дарія Вдовенко",
    //   description:
    //     "Молода бізнес леді Києва. З 10 років займалася спортом ( бойовим мистецтвом тхеквондо втф ) зайняла титул чемпіона України. Навчаюся на ветеринарному та на кінологічному відділенні в двох різних закладах. Я обожнюю виступати на сцені перед публікою. Мої головні слова по життю «Я бачу ціль і не бачу перешкод» цими словами я мотивую людей не здаватися вірити в себе та йти до своєї цілі. Так як я обожнюю тварин я люблю їм допомагати, часто допомагаю притулкам для тварин фінансово та медичною допомогою. На цей проєкт я вирішила піти с ціллю показати всюму світу які в нас українські жінки, показати своїм власним прикладом що наші жінки сильні, красиві, абіціозні, незалежні. Як наша країна.",
    //   voteCount: 23,
    //   link: "https://send.monobank.ua/jar/9ipiqtNYAn",
    // },
    // {
    //   id: 6,
    //   imageUrl: require("../assets/images/queens/6.jpg"),
    //   fullName: "Аліна Сидельник",
    //   description:
    //     "Мене звуть Аліна Сидельник, мені 20 років. <br/>\nЯ з прифронтового міста Торецька Донецької області, зараз тимчасово мешкаю у місті Вінниця. <br/>\nМрію стати відомою моделлю та учасницею конкурсів краси світового рівня. <br/>\nБрала участь у конкурсах краси «Міс Торецьк 2019» та «Топ-модель Дніпро 2023». <br/>\nРазом із модельною школою ELmodEL посіла 1 місце у щорічній київській битві модельних агенцій Fashion Awards 2021.",
    //   voteCount: 1,
    //   link: "https://send.monobank.ua/jar/RV5gZd9Up",
    // },
    // {
    //   id: 7,
    //   imageUrl: require("../assets/images/queens/7.jpg"),
    //   fullName: "Ярослава Галіцька",
    //   description:
    //     "м. Київ 39 років. Працюю в правоохоронних органах, маю юридичну освіту за спеціальністю юрист. Я не волонтер, у мене не має свого фонду. Також я люблю тварин ми іноді з сином ходимо до притулку кормити та брати гуляти з тваринами. Тож намагалась одному песику збирати кошти на лікування. На конкурс хочу за новими цікавими знайомствами.",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/6wXsqkQ77",
    // },
    // {
    //   id: 8,
    //   imageUrl: require("../assets/images/queens/8.jpg"),
    //   fullName: "Анна Корнєєва",
    //   description:
    //     "м. Львів<br/>\nЗріст 167 см, вага 46 кг<br/>\nРозмір хс<br/>\n36 років<br/>\nМаю власну справу логістичні послуги по Україні та закордоном, мама трьох дітей <br/>\nЛюблю проводити час з дітьми, та обожнюю свою роботу, охоче волонтерю для потреб ЗСУ, вірю в нашу перемогу! хобі фітнес, медитації, музика, малювання",
    //   voteCount: 155,
    //   link: "https://send.monobank.ua/jar/3J2ao82gp",
    // },
    // {
    //   id: 12,
    //   imageUrl: require("../assets/images/queens/9.jpg"),
    //   fullName: "Дарина Пурдік",
    //   description:
    //     "Вітаю, друзі<br/>\nМене звати Дарина<br/>\nЯ кмітлива та завзята, впевнена в собі та фотогенічна<br/>\nЛюблю творчість, креативи та нові враження<br/>\nХочу бути корисною людям, тому навчаюся на лікаря<br/>\nТакож мрію про кар'єру моделю, тому сподіваюся на перемогу в цьому конкурсі",
    //   voteCount: 8,
    //   link: "https://send.monobank.ua/jar/8Sg16PQ3Ub",
    // },
    // {
    //   id: 13,
    //   imageUrl: require("../assets/images/queens/10.jpg"),
    //   fullName: "Тетяна Сметюк",
    //   description:
    //     "Привіт, я Тетяна Сметюк і я обожнюю життя!<br/>\nПрацюю майстром манікюру у власній студії, а також 3 роки я займаюсь спортом, спорт для мене це образ життя, нещодавно почала займатися боксом.<br/>\nДуже хочу себе спробувати у конкурсі краси адже це унікальна можливісь спробувати щось нове, буду вдячна за вашу підтримку!",
    //   voteCount: 0,
    //   link: "https://send.monobank.ua/jar/8Z8kgaC5zw",
    // },
    // {
    //   id: 14,
    //   imageUrl: require("../assets/images/queens/11.jpeg"),
    //   fullName: "Юлія Іваницька",
    //   description:
    //     "З перших днів війни я пішла добровольцем захищати нашу країну та волонтерила в харківському добробаті «Хартія».<br/>\nХоч і мрії стати солдатом перешкодило здоровʼя, та це не завадило мені отримати військову нагороду за активну волонтерську діяльність та навіть позивний) <br/>\nЩе одна моя мрія- піднімати бойовий дух піснями, адже моїм військовим позивним був «Співачка». <br/>\nЗа професією я акторка дубляжу та озвучування. <br/>\nМрію нести добро, красу та відданість. А цей конкурс та ваш голос може в цьому допомогти.<br/>\nМожна ще довго говорити про любов, добро та допомогу військовим - а можна діяти з любовʼю до них!<br/>\nPray for Ukraine🇺🇦",
    //   voteCount: 779,
    //   link: "https://send.monobank.ua/jar/9ziyMYfeQC",
    // },
    // {
    //   id: 15,
    //   imageUrl: require("../assets/images/queens/12.jpg"),
    //   fullName: "Анастасія Грушко",
    //   description:
    //     "Красуня з міста Вінниця. Працює тренером з повітряної акробатики та циркових мистецтв для дітей. Також дівчина цікавиться колекціонуванням старовинних римських срібних та золотих монет.<br/>\nУ вільний час займається волонтерством та фінансує певні потреби окремих бригад самостійно.<br/>\nТакож підтримує економіку країни допомагаючи фінанансово молодому поколінню, які почали займатись підприємницькою діяльність!<br/>\nЗ власного бюджету профінансувала автомобіль для 3-і роти 321 батальйону СТО ЗСУ Та прямо підтримує військову частину А3547 ПСЗСУ.",
    //   voteCount: 650,
    //   link: "https://send.monobank.ua/jar/3ZH4M6QSXo",
    // },
    // {
    //   id: 1,
    //   imageUrl: require("../assets/images/queens/14.jpg"),
    //   fullName: "Марта Николенко",
    //   description: "Львів",
    //   voteCount: 188,
    //   link: "https://send.monobank.ua/jar/45cCS9c51s",
    // },
    // {
    //   id: 2,
    //   imageUrl: require("../assets/images/queens/17.jpg"),
    //   fullName: "Єлизавета Тріщанович",
    //   description: "Миколаїв",
    //   voteCount: 612,
    //   link: "https://send.monobank.ua/jar/3VkGKWDKNr",
    // },
    // {
    //   id: 3,
    //   imageUrl: require("../assets/images/queens/15.jpg"),
    //   fullName: "Анастасія Браєвська",
    //   description: "Київ",
    //   voteCount: 18,
    //   link: "https://send.monobank.ua/jar/8Z8kgaC5zw",
    // },
    // {
    //   id: 4,
    //   imageUrl: require("../assets/images/queens/12.jpg"),
    //   fullName: "Анастасія Грушко",
    //   description: "Вінниця",
    //   voteCount: 3344,
    //   link: "https://send.monobank.ua/jar/6zLnTzcoor",
    // },
    // {
    //   id: 5,
    //   imageUrl: require("../assets/images/queens/16.jpg"),
    //   fullName: "Яна Мазун",
    //   description: "Овруч",
    //   voteCount: 497,
    //   link: "https://send.monobank.ua/jar/6wXsqkQ77",
    // },
    // {
    //   id: 6,
    //   imageUrl: require("../assets/images/queens/13.jpg"),
    //   fullName: "Вікторія Власенко",
    //   description: "Київ",
    //   voteCount: 2033,
    //   link: "https://send.monobank.ua/jar/7oyZqz62TY",
    // },
    // {
    //   id: 7,
    //   imageUrl: require("../assets/images/queens/18.jpg"),
    //   fullName: "Ірина Світленко",
    //   description: "Київ",
    //   voteCount: 627,
    //   link: "https://send.monobank.ua/jar/6Z2Yf8D1AR",
    // },
    // {
    //   id: 8,
    //   imageUrl: require("../assets/images/queens/5.jpg"),
    //   fullName: "Дарія Вдовенко",
    //   description: "Київ",
    //   voteCount: 11,
    //   link: "https://send.monobank.ua/jar/2EoSwUfY8J",
    // },
    // {
    //   id: 9,
    //   imageUrl: require("../assets/images/queens/11.jpeg"),
    //   fullName: "Юлія Іваницька",
    //   description: "Київ",
    //   voteCount: 55,
    //   link: "https://send.monobank.ua/jar/9n8WWqZLe7",
    // },
  ];
});
</script>
